




























































































import { Vue, Prop, Component, p } from "av-ts";

import { IBadge } from "../../interfaces/models";
import BadgeService from "../../services/BadgeService";

@Component()
export default class Badges extends Vue {
    @Prop badge = p<IBadge>({
        required: true
    });

    get badgeIcon() {
        return BadgeService.badgeToIcon(this.badge);
    }

    get userHasBadge(): boolean {
        return this.badge.progress == 100;
    }

    get userHasStartedBadge(): boolean {
        return this.badge.progress > 0;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/util/UserBadge.vue